
import iTable from "../../../../components/Table.vue";
import { domainName, processApi } from "../../../../utility/index"
import detailsTable from "./Plugin/detailsTable.vue"

export default {
  components: {
    iTable, detailsTable
  },
  data() {
    return {
      requestSerialNumber: "",
      ruleForm: {
        requestSerialNumber: "",
        carId: "",
        manufactureNum: "",
        plateNum: "",
        description: "",
        filePath: "",
        urgeCount: "",
        repairStateStr: "",
        happenTime: "",
        closeTime: "",
      },
      height: '400',
      list: [
        {
          serialNumber: '1111'
        }
      ],
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: false,
        serialNumber: true,
      },
      columns: [
        {
          prop: "serialNumber",
          label: this.$t('Details.repairOrderSerial'),
          align: "center",
          width: "180px"
        },
        {
          prop: "carId",
          label: this.$t('common.carId'),
          align: "center",
        },
        {
          prop: "manufactureNum",
          label: this.$t('common.manufactureNum'),
          align: "center",
          width: "150px"
        },
        {
          prop: "receiveTime",
          label: this.$t('Details.orderAcceptanceTime'),
          align: "center",
          width: "180px"
        },
        {
          prop: "receiveDuration",
          label: this.$t('Details.responseTime'),
          align: "center",
          width: "120px"
        },
        {
          prop: "userName",
          label: this.$t('VehicleManagement.maintenancePerson'),
          align: "center",
          width: "120px"
        },
        {
          prop: "repairTypeStr",
          label: this.$t('Details.faultClassification'),
          align: "center",
          width: "160px",
          // render: (h, params) => {
          //     return h('el-tag', {
          //         props: { type: params.row.state === '' ? '' : params.row.state === 0 ? 'danger' : 'success' }
          //     }, params.row.state === '' ? '' : params.row.state === 0 ? this.$t('VehicleManagement.unFinish') : this.$t('VehicleManagement.finish'))
          // }

        },
        {
          prop: "peopleCost",
          label: this.$t('VehicleManagement.peopleCost'),
          align: "center",
          width: "120px"
        },

        {
          prop: "materialCost",
          label: this.$t('Details.materialCost'),
          align: "center",
          width: "200px"
        },
        {
          prop: "sumCost",
          label: this.$t('Details.totalCost'),
          align: "center",
          width: "160px"
        },
        {
          prop: "operateTime",
          label: this.$t('VehicleManagement.operateTime'),
          align: "center",
          width: "180px"
        },
        {
          prop: "operateDuration",
          label: this.$t('Details.repairDuration'),
          align: "center",
          width: "120px",

        }
      ],
      // dialogDetailsFormVisible: false,
      dialogOperateVisible: false,
      operates: {
        width: 100,
        fixed: "right",
        list: [
          {
            id: '1',
            show: true,
            icon: 'iconfont iconicon-chakanxq',
            plain: true,
            disabled: false,
            isBtn: "REPAIRFORM_DETAIL",
            method: (index, row) => {
              this.dialogOperateVisible = true
              this.serialNumber = row.serialNumber
              this.queryDetails(index, row)
              // this.dialogDetailsFormVisible = true
              // this.queryDetails(index, row)
              // this.$router.push({
              //     path: '/VehicleManagement/RepairManagement/Details',
              //     // query: {dictId: row.id}
              // })
            }
          }
        ],
      },
      processImg: processApi,
      FileList: [],
      imageUrl: "",
      dialogVisible: false,
      FileList: [],
      // sumCost: 0,
      serialNumber: "",
      imgUrl: "",
      dialogVisibles: false,
      dialogForm: {
        serialNumber: "",
        receiveTime: "",
        receiveDuration: "",
        userName: "",
        repairTypeStr: "",
        isArtificialDamageStr: "",
        peopleCost: "",
        materialCost: "",
        operateTime: "",
        operateDuration: "",
        filePath: "",
      },

      OperateForm: {
        requestSerialNumber: '',
        carId: '',
        carWorkTime: '',
        operateUser: '',
        operateTime: '',
        repairType: '',
        remarks: '',
        peopleCost: '',
        materialCost: '',
        filePath: ''
      },
      FileOperateList: [],
      dialogFileOperateVisible: false,
      imageOperateUrl: '',
      OperateLabelWidth: '126px',
      // DialogProps: {
      //   dialogFormVisible: false,
      //   dialogTitle: "",
      //   dialogWidth: "",
      //   dialogCloseBtnText: "",
      //   dialogSuccessBtnText: "",
      //   dialogIsFooter: false,
      // }
    };
  },
  mounted() {
    if (this.$route.query.requestSerialNumber) {
      this.requestSerialNumber = this.$route.query.requestSerialNumber;
    }
    this.getDeails();
  },
  methods: {
    getDeails() {
      let param = {
        requestSerialNumber: this.requestSerialNumber,
      }
      this.$store.dispatch('RepairManagement/GET_GETREQUESTREPAIR', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.ruleForm = res.data.data
            this.ruleForm.filePath = res.data.data.filePath;
            this.FileList = [];
            if (res.data.data.filePath) {
              let txt = res.data.data.filePath.split(",");
              txt.forEach((item, index) => {
                console.log(item)
                this.FileList.push({
                  // name: `${index}.png`,
                  url: item,
                });
              });
            }
            this.list = res.data.data.repairList;
          }
        }
      }).catch(err => { })
    },

    // handlePictureCardPreview(uploadFile) {
    //   console.log(uploadFile)
    //   this.imageUrl = uploadFile.url;
    //   this.dialogVisible = true;
    // },

    // handleAction(command, row) {
    //   switch (command) {
    //     case "handle":
    //       console.log(row);
    //       this.DialogProps.dialogFormVisible = true;
    //       this.DialogProps.dialogTitle = "维修详情";
    //       this.DialogProps.dialogWidth = "660px";
    //       this.DialogProps.dialogCloseBtnText = "取消";
    //       this.DialogProps.dialogSuccessBtnText = "确定";
    //       this.DialogProps.dialogIsFooter = false;
    //       this.dialogForm = { ...row };
    //       this.FileList = [];
    //       if (row.filePath) {
    //         let txt = row.filePath.split(",");
    //         txt.forEach((item, index) => {
    //           this.FileList.push({
    //             name: `${index}.png`,
    //             url: item,
    //           });
    //         });
    //       }
    //       this.serialNumber = row.serialNumber;
    //       this.getDetailList();
    //       this.sumCost = row.sumCost;
    //       break;
    //     default:
    //       break;
    //   }
    // },

    // getDetailList() {
    //   this.$HTTP
    //     .POSTForm(this.$API.V3_MAINTENANCE_GETDETAILLIST, {
    //       costType: 0,
    //       serialNumber: this.serialNumber,
    //     })
    //     .then((res) => {
    //       this.BindList = res.data;
    //     });
    // },

    // handlePicCardPreview(uploadFile) {
    //   console.log(uploadFile)
    //   this.imgUrl = uploadFile.url;
    //   this.dialogVisibles = true;
    // },

    // dialogClose() {
    //   this.DialogProps.dialogFormVisible = false;
    // },

    goback() {
      const tabName = this.$route.query.tabName || 'first';
      const sourcePage = this.$route.query.sourcePage || 'repair'; // 默认返回报修管理

      if (sourcePage === 'maintain') {
        this.$router.push({
          path: "/VehicleManagement/MaintainManagement",
          query: { tabName: tabName }
        });
      } else {
        this.$router.push({
          path: "/VehicleManagement/RepairManagement",
          query: { tabName: tabName }
        });
      }
    },

    closeOperateDia() {
      this.dialogOperateVisible = false
    },
    queryDetails() {
      let param = {
        serialNumber: this.serialNumber,
      }
      this.$store.dispatch('RepairManagement/GET_GETREPAIR', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.$nextTick(() => {
              this.OperateForm = res.data.data
              this.FileOperateList = [];
              const arr = res.data.data.filePath.split(',')
              arr.forEach(filePath => {
                this.FileOperateList.push({
                  url: filePath,
                });
              });
              this.$refs.detailTable.id = res.data.data.serialNumber
              this.$refs.detailTable.getDetailList()
            })
          }
        }
      }).catch(err => { })
    },
    handleOperatePictureCardPreview(file) {
      this.imageOperateUrl = file.url;
      this.dialogFileOperateVisible = true;
    },

    down() {
      if (domainName) {
        if (domainName.split(':')[0] !== 'localhost') {
          let url = `https://${domainName}/v1/getExportExcel/exportRepairList?requestSerialNumber=${this.requestSerialNumber}`
          location.href = url
        } else {
          let host = 'localhost:8080'
          let url = `https://${host}/v1/getExportExcel/exportRepairList?requestSerialNumber=${this.requestSerialNumber}`
          location.href = url
        }
      }
    },
  },
  // computed: {
  //   tableColumn() {
  //     return tableColumn;
  //   },
  //   tableBindColumn() {
  //     return tableBindColumn;
  //   }
  // }
};